import KEY_CODES from '../../components/userDocuments/editDocument/editJournal/constants/keyCodes';

const specialCharCodes = [
  106, 107, 109, 111, 186, 187, 188, 189, 190, 191, 219, 220, 221, 222,
];

const filterMarks = (marks) => marks.filter((ele) => ele.type === 'comment');

export const getMarks = (editor) => {
  const leavesData = JSON.parse(
    JSON.stringify(editor.value.fragment.getTexts()),
  )[0];
  if (!leavesData) return [];
  const { leaves } = leavesData;
  return filterMarks(leaves[0].marks);
};

const getSelectionExpanded = (editor) => {
  const {
    value: {
      selection: { isExpanded },
    },
  } = editor;
  return isExpanded;
};

export const removeMark = async (marks, editor) => {
  marks.forEach(async (ele) => {
    if (ele.type === 'comment') {
      await editor.removeMark(ele);
    }
  });
};

export const deSelectMarks = async (editor) => {
  const {
    value: { selection, focusBlock: currFocusBlock },
  } = editor;
  editor.moveFocusBackward(1);

  const {
    value: { focusBlock: updatedFocusBlock1 },
  } = editor;
  if (currFocusBlock.key !== updatedFocusBlock1.key) {
    editor.select(selection);
    removeMark(editor.value.activeMarks, editor);
    return;
  }

  const moveFocusBackward = getSelectionExpanded(editor);
  const moveFocusBackwardMarks = getMarks(editor);
  editor.select(selection);
  if (moveFocusBackward && moveFocusBackwardMarks.length) {
    editor.moveFocusForward(1);

    const {
      value: { focusBlock: updatedFocusBlock2 },
    } = editor;
    if (currFocusBlock.key !== updatedFocusBlock2.key) {
      editor.moveFocusBackward(1);
    }

    const moveFocusForward = getSelectionExpanded(editor);
    if (moveFocusForward) {
      editor.moveToFocus();
      const moveFocusForwardMarks = getMarks(editor);
      editor.select(selection);
      if (
        (moveFocusForward && moveFocusForwardMarks.length === 0) ||
        !moveFocusForward
      ) {
        await removeMark(moveFocusBackwardMarks, editor);
      }
    } else {
      await removeMark(moveFocusBackwardMarks, editor);
    }
  } else if (moveFocusBackward && moveFocusBackwardMarks.length === 0) {
    editor.moveFocusForward(1);
    const moveFocusForward = getSelectionExpanded(editor);
    const moveFocusForwardMarks = getMarks(editor);
    editor.select(selection);

    if (moveFocusForward && moveFocusForwardMarks.length) {
      await removeMark(moveFocusForwardMarks, editor);
    }
  }
};

export const removeCommentPopup = ({
  editor,
  updatePopUpKeys,
  showCommentCard,
  showContextCard,
}) => {
  const {
    value: {
      selection: { isExpanded },
    },
  } = editor;
  if (!isExpanded && (showCommentCard || showContextCard)) {
    updatePopUpKeys({
      currentCommentIds: [],
      top: 0,
      left: 0,
      commentCard: {},
      isContextMenu: {},
      activeCommentId: '',
    });
  }
};

const stopExtension = async ({
  editor,
  updatePopUpKeys,
  showCommentCard,
  showContextCard,
  event,
}) => {
  const { keyCode, ctrlKey, metaKey, shiftKey } = event;

  const arrowKey = [
    KEY_CODES.RIGHT,
    KEY_CODES.LEFT,
    KEY_CODES.UP,
    KEY_CODES.DOWN,
  ].includes(keyCode);
  if (
    !(
      ((ctrlKey || metaKey) && KEY_CODES.B) ||
      ((ctrlKey || metaKey) && KEY_CODES.I) ||
      ((ctrlKey || metaKey) && KEY_CODES.U)
    ) &&
    !((ctrlKey || metaKey) && keyCode === KEY_CODES.X) &&
    !((ctrlKey || metaKey) && keyCode === KEY_CODES.C) &&
    !(shiftKey && arrowKey) &&
    (((ctrlKey || metaKey) && keyCode === KEY_CODES.V) ||
      (keyCode >= KEY_CODES.A && keyCode <= KEY_CODES.Z) ||
      (keyCode >= 96 && keyCode <= 105) ||
      (keyCode >= 48 && keyCode <= 57) ||
      specialCharCodes.includes(keyCode) ||
      keyCode === 32)
  ) {
    if (!arrowKey) await deSelectMarks(editor);
    let activeMarks = JSON.stringify(editor.value.activeMarks);
    activeMarks = JSON.parse(activeMarks);
    if (!activeMarks.length || !arrowKey)
      removeCommentPopup({
        editor,
        updatePopUpKeys,
        showCommentCard,
        showContextCard,
      });
  }
};

export default stopExtension;
